// extracted by mini-css-extract-plugin
export default {"root":"add-section-button_root__2MVa3","button":"add-section-button_button__z4IkD","icon":"add-section-button_icon__B3G5T","callToAction":"add-section-button_callToAction__3MXBK"};